import { makeRequest } from '../../../lib/api';

const ROLES_PATH = '/v1/roles';
const OPERATIONS_PATH = '/v1/operations';
const PERMISSIONS_ROLES_PATH = '/v1/permissions/roles';
const PERMISSIONS_USERS_PATH = '/v1/permissions/users';
const PERMISSIONS_PATH = '/v1/permissions';
const SERVICES_PATH = '/v1/services';
const SERVICE_ROLE_PATH = '/v1/service_role';
const SERVICE_USERS_PATH = '/v1/users/services';
const USER_ROLE_PATH = '/v1/user_roles';
const SERVICE_PARTNER_PATH = '/v1/service_partner';
const PROJECT_PATH = '/v1/nik/projects';
const SERVICE_REGION_PATH = '/v1/service_region';

class permissionsController {
  /** Роли */

  getRoles = (request = {}) => {
    const partnerFiler = request.partnerId ? `&partnerId=${ request.partnerId }` : '';
    return makeRequest('get', `${ ROLES_PATH }?showDeleted=${ request.showDeleted ?? true }${ partnerFiler }`);
  };

  getPossibleParentRoles = (data = { partnerId: '', roleId: '' }) => {
    let getString = `${ ROLES_PATH }/possible_parents?`;
    if (data.partnerId) getString += `&partnerId=${ data.partnerId }`;
    if (data.roleId) getString += `&roleId=${ data.roleId }`;
    return makeRequest('get', getString);
  };

  getTemplateRoles = () => {
    return makeRequest('get', `${ ROLES_PATH }/templates`);
  };

  createRole = (data = {}) => {
    return makeRequest('post', `${ ROLES_PATH }`, data);
  };

  deleteRole = (id) => {
    return makeRequest('delete', `${ ROLES_PATH }/${ id }`);
  };

  updateRole = (data = {}) => {
    return makeRequest('put', `${ ROLES_PATH }/${ data.id }`, data);
  };

  /** Сервисы */

  getServices = () => {
    return makeRequest('get', `${ SERVICES_PATH }`);
  };

  getAuthenticatedPartnersServices = (data = {}) => {
    return makeRequest('get', `${ SERVICES_PATH }/partner`, data);
  };

  getAuthenticatedUserServices = (data = {}) => {
    return makeRequest('get', `${ SERVICES_PATH }/user`, data);
  };

  createService = (data = {}) => {
    return makeRequest('post', `${ SERVICES_PATH }`, data);
  };

  updateService = (data = {}) => {
    return makeRequest('put', `${ SERVICES_PATH }/${ data.id }`, data);
  };

  /**
   *  Удалить сервис. Удалённому сервису проставляется Deleted_Date в базе.
   *  И он не показывается. Можно смело удалять. Это поправимая операция.
   */
  deleteService = (data = {}) => {
    return makeRequest('delete', `${ SERVICES_PATH }/${ data.id }`, data);
  };

  /** Сервисы, привязанные к роли */

  getServiceRole = (data = {}) => {
    return makeRequest('get', `${ SERVICE_ROLE_PATH }/role/${ data.roleId }?${ data.partnerId ? `partnerId=${ data.partnerId }` : '' }`);
  };

  createServiceRole = (data = {}) => {
    return makeRequest('post', `${ SERVICE_ROLE_PATH }`, data);
  };

  deleteServiceRole = (data = {}) => {
    return makeRequest('delete', `${ SERVICE_ROLE_PATH }/${ data.serviceRoleId }`, data);
  };

  /** Пользователи, работающие с указанным сервисом */

  getServiceUsers = data => {
    const { serviceId, ...rest } = data;
    return makeRequest('post', `${ SERVICE_USERS_PATH }/${ serviceId }`, rest);
  };

  /** Операции */

  getOperations = (data = {}) => {
    return makeRequest('get', `${ OPERATIONS_PATH }`, data);
  };

  createOperation = (data = {}) => {
    return makeRequest('post', `${ OPERATIONS_PATH }`, data);
  };

  updateOperation = (data = {}) => {
    return makeRequest('put', `${ OPERATIONS_PATH }/${ data.id }`, data);
  };

  /**
   *  Удалить операцию. Удалённой роли проставляется Deleted_Date в базе.
   *  И она не показывается. Можно смело удалять. Это поправимая ситуация.
   */
  deleteOperation = (data = {}) => {
    return makeRequest('delete', `${ OPERATIONS_PATH }/${ data.id }`, data);
  };

  /** Операции, привязанные к роли */

  getPermissionRole = (data = {}) => {
    // API возвращает список разрешений на любой айдишник роли, не проверяя,
    // существует такая роль в системе или нет.
    // Поэтому приходится возвращать пустые данные, хотя бы на явно некорректные роли,
    // что бы не отображать список разрешений для таких ролей в компонентах
    if (data.roleId < 1) {
      return Promise.resolve([]);
    }
    return makeRequest('get', `${ PERMISSIONS_ROLES_PATH }/${ data.roleId }`, data);
  };

  getPermissionUser = (data = {}) => {
    return makeRequest('get', `${ PERMISSIONS_USERS_PATH }/${ data.userId }`, data);
  };

  createPermission = (data = {}) => {
    return makeRequest('post', `${ PERMISSIONS_PATH }`, data);
  };

  updatePermission = (data = {}) => {
    return makeRequest('put', `${ PERMISSIONS_PATH }`, data);
  };

  /** Доступные пользователю права */

  getUserPermissions = (data = {}) => {
    return makeRequest('get', `/v1/users/${ data.customerId }/operations?projectId=${ data.projectId }`, data);
  };

  /** Роли, привязанные к пользователю */

  getCustomerRoles = (data = {}) => {
    return makeRequest('get', `${ USER_ROLE_PATH }/users/${ data.customerId }`, data);
  };

  createCustomerRoles = (data = {}) => {
    return makeRequest('post', `${ USER_ROLE_PATH }`, data);
  };

  deleteCustomerRoles = (data = {}) => {
    return makeRequest('delete', `${ USER_ROLE_PATH }/${ data.userRoleId }`, data);
  };

  /** Привязка партнёров к сервису */

  getServicePartner = (data = {}) => {
    return makeRequest('get', `${ SERVICE_PARTNER_PATH }/partner/${ data.partnerId }`, data);
  };

  createServicePartner = (data = {}) => {
    return makeRequest('post', `${ SERVICE_PARTNER_PATH }`, data);
  };

  deleteServicePartner = (id) => {
    return makeRequest('delete', `${ SERVICE_PARTNER_PATH }/${ id }`);
  };

  getPermissionsByOperation = (data) => {
    return makeRequest('get', `${ PERMISSIONS_PATH }/operations/${ data.id }`, data);
  };

  /** управление разрешениями партнёров */
  getPartnerPermissions = (data = {}) => {
    return makeRequest('get', `${ PERMISSIONS_PATH }/partners/${ data.partnerId }`);
  };

  postPartnerPermissions = (data = {}) => {
    return makeRequest('post', `${ PERMISSIONS_PATH }/partners`, data);
  };

  // Проекты Ник-Асситанс:
  getProjects = () => {
    return makeRequest('get', `${ PROJECT_PATH }`);
  };

  /** Роли, привязанные к пользователю */

  getServiceRegions = (data = {}) => {
    return makeRequest('get', `${ SERVICE_REGION_PATH }/users/${ data.customerId }`, data);
  };

  createServiceRegion = (data = {}) => {
    return makeRequest('post', `${ SERVICE_REGION_PATH }`, data);
  };

  updateServiceRegion = (data = {}) => {
    return makeRequest('put', `${ SERVICE_REGION_PATH }`, data);
  };

  deleteServiceRegion = (id) => {
    return makeRequest('delete', `${ SERVICE_REGION_PATH }/${ id }`);
  };
}

export default new permissionsController();
